<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-num" id="C1">1</p>
<p class="chap-title">A FEW DEFINITIONS</p>
<p class="noindent">The following are some helpful definitions of terms used in the interurban stories that may be unfamiliar to some readers.</p>
<ul>
<li>car: Short for <i>interurban car</i>. Interurban cars were essentially souped-up, sometimes lavishly appointed trolley cars. Most had powerful motors and high-speed gearing, and they were usually larger and heavier than their city cousins. Cars were numbered, like “car 360,” which is on display at the Interurban Railway Museum in Plano.</li>
<li>motorman: A rail vehicle operator.</li>
<li>siding: A short section of railway track connected to a main line, usually parallel to a rail station, that allowed other cars trains on the same line to pass.</li>
<li>trolley:
<ul class="top">
<li>A streetcar powered electrically through a trolley, also referred to as a trolley car.</li>
<li> A device that carries an electric current from an overhead wire to an electrically driven vehicle.</li>
</ul></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1.vue?549f0af8